import React from "react";
import ReactDOM from "react-dom";
import { CustomersRating } from "shared-ui";
import { parseBoolean, secureGetAttribute, getBooleanAttributeValue } from "../utils";

export const ID = "customer-rating";

export function renderCustomerRating(selector = `#${ID}`) {
    const customerRatingInstances = Array.from(
        document.querySelectorAll(selector)
    );

    customerRatingInstances.forEach((element) => {
        const className = secureGetAttribute(element, "data-classname");
        const type = secureGetAttribute(element, "data-type");
        const slug = secureGetAttribute(element, "data-slug");
        const customerRating = parseInt(
            secureGetAttribute(element, "data-customer-rating") || 0,
            10
        );

        const ratingCount = parseInt(
            secureGetAttribute(element, "data-rating-count"),
            10
        );

        const ratingDisplayText = secureGetAttribute(element, "data-display-text");

        const shouldUseRatingsLink = getBooleanAttributeValue(
            element.getAttribute("data-use-ratings-link"),
            true
        );

        const ratingLinkURL = secureGetAttribute(element, "data-rating-url");
        const direction = secureGetAttribute(element, "data-direction");
        const theme = secureGetAttribute(element, "data-theme");
        const wrapLinks = parseBoolean(secureGetAttribute(element, "data-wrap-links"));
        const ratingLinkTarget = secureGetAttribute(element, "data-link-target");
        const withTooltip = parseBoolean(
            secureGetAttribute(element, "data-with-tooltip")
        );
        const description = secureGetAttribute(element, "data-description");

        ReactDOM.render(
            <CustomersRating
                className={className}
                type={type}
                slug={slug}
                customersRating={customerRating}
                ratingCount={ratingCount}
                ratingDisplayText={ratingDisplayText}
                shouldUseRatingsLink={shouldUseRatingsLink}
                ratingLinkURL={ratingLinkURL}
                direction={direction}
                theme={theme}
                wrapLinks={wrapLinks}
                ratingLinkTarget={ratingLinkTarget}
                withTooltip={withTooltip}
                description={description}
            />,
            element
        );
    });
}

document.addEventListener('DOMContentLoaded', function() {
    renderCustomerRating();
});
